import * as yup from "yup";

export const userSchema = yup
  .object({
    name: yup
      .string()
      .required("Please enter your name 77")
      .min(3, "Please enter full name"),
    mobile: yup
      .string()
      .min(8, "Number should be minimum 8 characters")
      .max(14, "Number should be maximum 14 characters")
      .required("Please enter a valid phone number"),
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter a valid email address"),
    goal: yup.string().required("Please select a health goal"),
    promoCode: yup.string(),
  })
  .required();

export const donorSchema = yup
  .object({
    donorName: yup
      .string()
      .required("Please enter your name 88")
      .min(3, "Please enter full name"),
    donorNameCountryCode: yup.string().required().default("+91"),
    donorMobile: yup
      .string()
      .min(8, "Number should be minimum 8 characters")
      .max(14, "Number should be maximum 14 characters")
      .required("Please enter a valid phone number"),
    donorEmail: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter a valid email address"),
  })
  .required();
